
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface VerificationErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string | null;
}

const VerificationErrorDialog: React.FC<VerificationErrorDialogProps> = ({
  isOpen,
  onClose,
  errorMessage,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-red-600">Verification Error</DialogTitle>
          <DialogDescription>
            There was a problem verifying your email address:
          </DialogDescription>
        </DialogHeader>
        <div className="bg-red-50 p-4 rounded-md text-red-600 mt-2">
          {errorMessage || "The verification link is invalid or has expired."}
        </div>
        <div className="mt-5">
          <p className="text-sm text-gray-500">
            This could happen if:
            <ul className="list-disc pl-5 mt-2">
              <li>The verification link has expired</li>
              <li>You've already verified your email</li>
              <li>There was a problem with the verification process</li>
            </ul>
          </p>
          <p className="text-sm text-gray-500 mt-3">
            Please try signing in. If you can't sign in, try:
          </p>
          <ul className="list-disc pl-5 mt-1 text-sm text-gray-500">
            <li>Signing up again with the same email</li>
            <li>Using the password reset option</li>
            <li>Contacting support if problems persist</li>
          </ul>
        </div>
        <div className="flex justify-end mt-4">
          <Button onClick={onClose}>Close</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VerificationErrorDialog;
